import { useEffect } from 'react';

export default function useEventListener<
  K extends keyof HTMLElementEventMap | keyof SVGElementEventMap,
  T extends HTMLElement | SVGElement,
>(
  eventName: K,
  handler: (this: HTMLElement | SVGElement, ev: HTMLElementEventMap[K] | SVGElementEventMap[K]) => void,
  targetNode: T | undefined,
): void {
  useEffect(() => {
    // Make sure element supports addEventListener
    const isSupported = targetNode && targetNode.addEventListener;
    if (!isSupported || !targetNode) return;

    // Add event listener
    if (targetNode instanceof SVGElement) {
      targetNode.addEventListener<K>(eventName, handler);
    } else {
      targetNode.addEventListener<K>(eventName, handler);
    }

    // Remove event listener on cleanup
    return () => {
      if (targetNode instanceof SVGElement) {
        targetNode.removeEventListener<K>(eventName, handler);
      } else {
        targetNode.removeEventListener<K>(eventName, handler);
      }
    };
  }, [eventName, targetNode, handler]);
}
